<template>
    <multi-page-item-settings
        class="h-full"
        :items-array="form.products"
        :settings="settings"
        :default-close-handler="defaultCloseHandler"
    >
        <template slot-scope="{ edit, save, restore, selectedItem }">
            <form-rsvp-block-general-settings
                key="general-settings"
                :block="block"
                :form="form"
                @edit-item="edit"
            ></form-rsvp-block-general-settings>
            <form-product-item-settings
                key="item-settings"
                use-guest-attending-titles
                :event="event"
                :block="block"
                :item="selectedItem"
                @save-settings="save"
                @cancel="restore"
            ></form-product-item-settings>
        </template>
    </multi-page-item-settings>
</template>

<script>
import Form from '@/validation/Form';
import HasDefaultCloseHandler from '@/mixins/HasDefaultCloseHandler';
import BlockableSettingsMixin from '@/mixins/BlockableSettingsMixin';

export default {
    mixins: [HasDefaultCloseHandler, BlockableSettingsMixin],

    data () {
        const maxCapacity = { ...this.event.settings.maxCapacity };

        this.$emit('original-settings-override-input', { maxCapacity });

        return {
            form: new Form(
                Object.assign(this.settings, {
                    products: this.block.pivot.products,
                    maxCapacity
                })
            )
        };
    }
};
</script>
